import { render, staticRenderFns } from "./SupplierDocuments.vue?vue&type=template&id=72d26304&scoped=true"
import script from "./SupplierDocuments.vue?vue&type=script&lang=ts"
export * from "./SupplierDocuments.vue?vue&type=script&lang=ts"
import style0 from "./SupplierDocuments.vue?vue&type=style&index=0&id=72d26304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d26304",
  null
  
)

export default component.exports